import { render, staticRenderFns } from "./queryData.vue?vue&type=template&id=6997415f&scoped=true&"
import script from "./queryData.vue?vue&type=script&lang=js&"
export * from "./queryData.vue?vue&type=script&lang=js&"
import style0 from "./queryData.vue?vue&type=style&index=0&id=6997415f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6997415f",
  null
  
)

export default component.exports